import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./BeefReleaseYourRage.css";
import Hero from "./components/Hero";
import PartnersSection from "./components/PartnersSection";
import MapSection from "./components/MapSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function BeefReleaseYourRage() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="beef-rage-page">
      <Helmet>
        <title>BEEF · Release Your Rage, Find Your Calm | Netflix</title>
        <meta
          name="description"
          content="Experience a week of wellness brought to you by BEEF, celebrating 16 Emmy nominations for Outstanding Limited Series. August 10–14 across Los Angeles."
        />
      </Helmet>

      <Hero />
      <PartnersSection />
      <MapSection />
      <FaqSection />
      <Footer />
    </div>
  );
}
